import moment from 'moment'

import * as types from './mutation-types'

import { normalizeUser } from '@/legacy/store/helpFunctions'

const startDate = moment(1, 'DD').format('YYYY-MM-DD') // First day this month
const endDate = moment().format('YYYY-MM-DD') // Now
const shortcut = moment().date()

export default {
  namespaced: true,
  state: {
    dataDateRange: { start: startDate, end: endDate, shortcut: shortcut, key: 'thisMonth' },
    // Legacy Token for backward compatibility legacy store and Repositories
    token: null,
    user: null,
    error: null,
    isLoading: false,
  },

  // getters
  getters: {
    user: (state) => state.user,
    dataDateRange: (state) => state.dataDateRange,
    token: (state) => state.token,
    check: (state) => state.user !== null,
    isAdmin: (state) => Boolean(state.user?.admin),
    stores: (state) => state.user?.stores,
    userId: (state) => state.user?.id,
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
  },

  // mutations
  mutations: {
    [types.SAVE_TOKEN]: (state, token) => {
      state.token = token
    },

    [types.FETCH_USER_SUCCESS]: (state, user) => {
      state.user = normalizeUser(user)
    },

    [types.UPDATE_DATA_DATE_RANGE]: (state, dateRange) => {
      state.dataDateRange = dateRange
    },

    [types.SET_ERROR]: (state, value) => (state.error = value),
    [types.SET_LOADING]: (state, value) => (state.isLoading = value),
  },
  actions: {
    setTokenFromAuthPinia({ commit }, token) {
      commit(types.SAVE_TOKEN, token)
    },
    setUserFromAppPinia({ commit }, payload) {
      commit(types.FETCH_USER_SUCCESS, payload)
    },
    clearUser({ state }) {
      state.user = null
      state.token = null
    },
    updateDataDateRange({ commit, dispatch }, dateRange) {
      commit(types.UPDATE_DATA_DATE_RANGE, dateRange)
      dispatch('fetchDataWithUpdatedDates', {}, { root: true })
    },
  },
}
